import React, { Component, Fragment } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CDropdownToggle,
  CProgress,
  CPagination,
  CTooltip
} from "@coreui/react";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn
} from "react-bootstrap-table";
import { withRouter } from "react-router-dom";

import data from "./dummy";
import {
  arrayToCSV,
  elementToPDF,
  arrayToXLSX,
  arrayToXLS
} from "../../utils/export";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";
import "./tables.css";

class DataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedList: [],
      header: []
    };

    this.table = data.rows;

    this.onToggleDropDown = toggleDropDown => {
      toggleDropDown();
    };

    this.renderSizePerPageDropDown = props => (
      <CDropdown className="d-inline-flex">
        <CDropdownToggle color="outline-secondary" className="text-muted">
          {props.currSizePerPage}
        </CDropdownToggle>
        <CDropdownMenu>
          {props.sizePerPageList.map((n, idx) => {
            const isActive = n.text === props.currSizePerPage ? "active" : null;
            return (
              <CDropdownItem
                key={idx}
                className={isActive}
                onClick={() => {
                  this.props.paginationData
                    ? this.props?.paginationData?.changeSizePerPage(n.text)
                    : props.changeSizePerPage(n.value);
                }}
              >
                {n.text}
              </CDropdownItem>
            );
          })}
        </CDropdownMenu>
      </CDropdown>
    );

    this.renderPaginationShowsTotal = (start, to, total) => {
      if (this.props.paginationData)
        return (
          <span style={{ marginRight: "10px" }}>
            Item {this.props?.paginationData?.firstItemIndex} até{" "}
            {this.props?.paginationData?.lastItemIndex}, em um total de{" "}
            {this.props?.paginationData?.totalItems} itens
          </span>
        );

      return (
        <span style={{ marginRight: "10px" }}>
          Item {start} até {to}, em um total de {total} itens
        </span>
      );
    };

    this.renderPaginationPanel = props => (
      <div className="w-100 p-1 d-flex flex-row align-items-center justify-content-between dt-pagination-panel">
        <div>
          {props.components.totalText}
          {this.props.paginationData && props.components.sizePerPageDropdown}
        </div>
        <CPagination
          align="end"
          className="mt-1"
          activePage={
            this.props.paginationData?.currPage ||
            this.props.currPage ||
            props.currPage
          }
          pages={
            this.props.paginationData?.totalPages ||
            this.props.totalPages ||
            props.totalPages ||
            1
          }
          onActivePageChange={page => {
            if (this.props.paginationData) {
              this.props.paginationData.changePage(page);
            } else if (this.props.changePage) {
              this.props.changePage(page);
            } else {
              props.changePage(page);
            }
          }}
        />
      </div>
    );

    this.createCustomInsertButton = onClick => (
      <button
        className="btnForm btn btn-primary ml-2"
        // Âncora do tour do professor (components/Tour/roteiros/professor.js). A
        // classe não serve de alvo porque não é única na página; os botões de
        // alocar e relatório já têm id próprio e não precisaram disto.
        data-tour="tabela-novo"
        onClick={this.props.insertAction}
      >
        <i className="fa fa-plus mr-2"></i>Novo
      </button>
    );

    this.createCustomDeleteButton = onClick => (
      <CDropdownItem onClick={onClick}>Apagar</CDropdownItem>
    );

    this.customConfirm = (next, dropRowKeys) => {
      const dropRowKeysStr = dropRowKeys.join(",");
      let answer = window.confirm(
        `Tem certeza que deseja deletar as selecionadas?`
      );
      if (answer) {
        this.props.deleteAction(dropRowKeys);
      }
    };

    this.createCustomExportCSVButton = onClick => (
      <CDropdownItem onClick={onClick}>Exportar</CDropdownItem>
    );

    this.createCustomSearchField = props => (
      <SearchField
        className="table-search-input"
        style={{ maxWidth: "200px" }}
        defaultValue={this.props.paginationData?.nameFilter || ""}
        placeholder="Procurar"
        onChange={e => {
          e.preventDefault();
          clearTimeout(this.searchTimer);

          this.searchTimer = setTimeout(() => {
            if (this.props.paginationData)
              this.props.paginationData.changeNameFilter(e.target.value);
            if (this.props.changeSearch && this.props.changePage) {
              this.props.changeSearch(e.target.value);
              this.props.changePage(1);
            }
          }, 1000);
        }}
      />
    );

    this.createCustomToolBar = props => (
      <div style={{ width: "100%" }}>
        <div className="card-header dt-toolbar d-flex align-items-center w-100">
          <div
            className="dt-toolbar-info"
            style={{ display: "flex", flexDirection: "column", flex: 1 }}
          >
            <h4 className="card-title mb-1 align-items-center">
              {this.props.backButton && (
                <i
                  className="fa fa-angle-left mr-3 font-weight-bold cursor"
                  onClick={() => this.props.history.goBack()}
                ></i>
              )}
              {this.props.title}
            </h4>
            <div className="small text-muted">
              {this.props.subtitle ||
                "Crie, edite e apague os itens dessa tabela"}
            </div>
          </div>
          {this.props.isRoomUsersPage && (
            <div className="d-flex flex-row justify-content-end mr-2 dt-toolbar-action">
              <CButton
                color="primary"
                className="text"
                onClick={() => {
                  this.props.toggleShowAllUsers();
                }}
              >
                {this.props.toggleShowAllUsersActivated
                  ? "Mostrar todos"
                  : "Paginar"}
              </CButton>
            </div>
          )}
          {!this.props.hideSearch && props.components.searchField}
          {props.components.insertBtn}
          {this.props.extraComponent}
          {(props.components.exportCSVBtn || props.components.deleteBtn) && (
            <CDropdown className="btn-group ml-2">
              <CDropdownToggle color="outline-secondary text-muted" />
              <CDropdownMenu>
                {props.components.exportCSVBtn}
                {props.components.deleteBtn}
              </CDropdownMenu>
            </CDropdown>
          )}
        </div>
        {this.props.filterComponent}
      </div>
    );

    this.onRowMouseOver = row => {
      /* const item = document.createElement("div");
      item.style.width = "600px";
      item.id = "rowEdit";
      item.innerHTML = "teste";
      document.querySelectorAll("tr")[row.id].lastChild.appendChild(item); */
    };

    this.onRowMouseOut = row => {
      /* document.querySelector("#rowEdit").outerHTML = ""; */
    };
  }

  componentDidMount() {
    // No primeiro segundo, não permite inserção no input de busca
    // Com isso, o navegador é impedido de fazer input indesejado
    const inputFields = document.querySelectorAll(".table-search-input");

    inputFields.forEach(input => {
      input.setAttribute("readonly", "readonly");
    });

    setTimeout(() => {
      inputFields.forEach(input => {
        input.removeAttribute("readonly");
      });
    }, 650);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    if (this.props.action) {
      let { header } = this.props;
      // `actionWidth` reserva a largura da coluna de ações. Sem ela, a coluna
      // fica com o que sobrar e, em telas médias, os últimos botões da linha
      // são cortados.
      header.push({
        name: "action",
        denomination: "Ações",
        width: this.props.actionWidth
      });
      this.setState({
        header
      });
    } else {
      this.getOptions().onRowClick = this.click;
      this.setState({
        header: this.props.header
      });
    }
    if (this.props.progressField) {
      let { header } = this.props;
      header.push({
        name: "progress",
        denomination: this.props.progressFieldName
      });
      this.setState({
        header: this.props.header
      });
    }
  }

  cellButton = (cell, row, enumObject, rowIndex) => (
    <div className="actionBtns">
      {this.props.btnView && (
        <Fragment>
          <CTooltip content={`${this.props.btnViewToolTip ?? "Visualizar"}`}>
            <button
              id={`viewBtn-${rowIndex}`}
              type="button"
              className="btn btn-info"
              onClick={() => this.view(row)}
            >
              <i className="fa fa-eye"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnAccept && (
        <Fragment>
          <CTooltip content={`${this.props.btnAcceptToolTip ?? "Aceitar"}`}>
            <button
              id={`btnAccept-${rowIndex}`}
              type="button"
              className="btn btn-success"
              onClick={() => this.accept(row)}
            >
              <i className="fa fa-check"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnEdit && (
        <Fragment>
          <CTooltip content={`${this.props.btnEditToolTip ?? "Editar"}`}>
            <button
              id={`editBtn-${rowIndex}`}
              type="button"
              className="btn btn-warning"
              data-placement="top"
              onClick={() => this.click(row)}
              disabled={[2, 3].some(id => id === row.status_id)}
            >
              <i className="fa fa-pencil"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnImportStudents && (
        <Fragment>
          <CTooltip
            content={`${
              this.props.btnImportStudentsToolTip ?? "Importar Estudantes"
            }`}
          >
            <button
              id={`importStudentsBtn-${rowIndex}`}
              type="button"
              className="btn btn-danger" // ← Mudei para vermelho
              onClick={() => this.importStudents(row)}
            >
              <i className="fa fa-download"></i> {/* ← Mudei o ícone */}
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnEditEvaluationBank && (
        <Fragment>
          <button
            id={`editBtn-${rowIndex}`}
            type="button"
            className="btn btn-warning"
            data-placement="top"
            onClick={() => this.click(row)}
          >
            Editar
          </button>
        </Fragment>
      )}
      {this.props.btnAnswerKeyEvaluationBank && (
        <Fragment>
          {((row.teacher_inserted !== null && row.teacher_inserted === false) ||
            row.teacher_inserted === "Impresso" ||
            row.grade === "Avaliação não realizada") && (
            <button
              id={`editBtn-${rowIndex}`}
              type="button"
              className={`btn ${
                row.teacher_inserted === ""
                  ? "btn-purple"
                  : "btn-orange text-white"
              }`}
              data-placement="top"
              onClick={() => this.answerKeyAction(row)}
            >
              {row.teacher_inserted === ""
                ? "Lançar respostas"
                : "Editar respostas"}
            </button>
          )}
        </Fragment>
      )}
      {this.props.btnDelete && (
        <Fragment>
          <CTooltip content={`${this.props.btnDeleteToolTip ?? "Deletar"}`}>
            <button
              id={`deleteBtn-${rowIndex}`}
              type="button"
              className="btn btn-danger"
              onClick={() => this.delete(row)}
            >
              <i className="fa fa-trash"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnPending && (
        <Fragment>
          <CTooltip content={`${this.props.btnPendingToolTip ?? "Pendente"}`}>
            <button
              id={`pendingBtn-${rowIndex}`}
              type="button"
              className="btn btn-warning"
              onClick={() => this.pending(row)}
            >
              <i className="fa fa-times"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnPrint && (
        <Fragment>
          <CTooltip content={`${this.props.btnPrintToolTip ?? "Imprimir"}`}>
            <button
              id={`printBtn-${rowIndex}`}
              type="button"
              className="btn btn-dark"
              onClick={() => this.print(row)}
            >
              <i className="fa fa-print"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnAllocate && (
        <Fragment>
          <CTooltip content={`${this.props.btnAllocateToolTip ?? "Alocar"}`}>
            <button
              id={`allocateBtn-${rowIndex}`}
              type="button"
              className="btn btn-success"
              onClick={() => this.allocate(row)}
            >
              <i className="fa fa-calendar"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnReport && (
        <Fragment>
          <CTooltip content={this.props.btnReportToolTip ?? "Relatório"}>
            <button
              id={`reportBtn-${rowIndex}`}
              type="button"
              className="btn btn-secondary"
              onClick={() => this.report(row)}
            >
              <i className="fa fa-bar-chart"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnMembers && (
        <Fragment>
          <CTooltip content={`${this.props.btnMembersToolTip ?? "Membros"}`}>
            <button
              id={`membersBtn-${rowIndex}`}
              type="button"
              className="btn btn-info"
              onClick={() => this.members(row)}
            >
              <i className="fa fa-group"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnStatistics && (
        <Fragment>
          <CTooltip
            content={`${this.props.btnStatisticsToolTip ?? "Estatísticas"}`}
          >
            <button
              id={`viewBtn-${rowIndex}`}
              type="button"
              className="btn btn-statistics"
              style={{ backgroundColor: "#34b157", color: "white" }}
              onClick={() => this.statistics(row)}
            >
              <i className="fa fa-bar-chart"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnPassword && (
        <Fragment>
          <button
            id={`passwordBtn-${rowIndex}`}
            className="btn btn-purple"
            onClick={() => this.changePassword(row)}
          >
            <i className="fa fa-lock"></i>
          </button>
        </Fragment>
      )}
      {this.props.btnUpload && (
        <Fragment>
          <CTooltip content={`${this.props.btnUploadToolTip ?? "Upload"}`}>
            <button
              id={`btnUpload-${rowIndex}`}
              type="button"
              className="btn btn-info"
              data-placement="top"
              onClick={() => this.upload(row)}
            >
              <i className="fa fa-upload"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnDecline && (
        <Fragment>
          <CTooltip content={`${this.props.btnDeclineToolTip ?? "Cancelar"}`}>
            <button
              id={`btnDecline-${rowIndex}`}
              type="button"
              className="btn btn-danger"
              onClick={() => this.props.listUpdateStatus("Liberado", row)}
            >
              <i className="fa fa-ban"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnMigrate && (
        <Fragment>
          <button
            id={`btnMigrate-${rowIndex}`}
            type="button"
            className="btn btn-warning"
            data-placement="top"
            onClick={() => this.migrate(row)}
          >
            <i className="fa fa-exchange"></i>
          </button>
        </Fragment>
      )}
      {this.props.btnRanking && (
        <Fragment>
          <CTooltip
            content={`${this.props.btnRankingToolTip ?? "Ranking da turma"}`}
          >
            <button
              id={`rankingBtn-${rowIndex}`}
              type="button"
              className="btn btn-danger"
              onClick={() => this.ranking(row)}
            >
              <i className="fa fa-trophy"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnDuplication && (
        <Fragment>
          <CTooltip
            content={`${this.props.btnDuplicationToolTip ?? "Duplicar"}`}
          >
            <button
              id={`btnMigrate-${rowIndex}`}
              type="button"
              className="btn btn-info"
              data-placement="top"
              onClick={() => this.duplicate(row)}
            >
              <i className="fa fa-clone"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnShare && (
        <Fragment>
          <CTooltip content={`${this.props.btnShareToolTip ?? "Compartilhar"}`}>
            <button
              id={`btnMigrate-${rowIndex}`}
              type="button"
              className="btn btn-dark"
              data-placement="top"
              onClick={() => this.share(row)}
            >
              <i className="fa fa-share-alt"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnShareQr && (
        <Fragment>
          <CTooltip
            content={`${
              this.props.btnShareQrToolTip ?? "Compartilhar QR Code"
            }`}
          >
            <button
              id={`btnMigrate-${rowIndex}`}
              type="button"
              className="btn btn-info"
              data-placement="top"
              onClick={() => this.props.btnShareQr(row)}
            >
              <i className="fa fa-qrcode"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
      {this.props.btnRowback && (
        <CTooltip content={`${this.props.btnRowbackToolTip ?? "Retornar"}`}>
          <Fragment>
            <button
              id={`btnMigrate-${rowIndex}`}
              type="button"
              className="btn btn-danger"
              data-placement="top"
              onClick={() => this.props.rowbackAction(row)}
            >
              <i className="fa fa-undo"></i>
            </button>
          </Fragment>
        </CTooltip>
      )}
      {this.props.btnDownloadFile && (
        <Fragment>
          <CTooltip
            content={`${this.props.btnDownloadFileToolTip ?? "Baixar arquivo"}`}
          >
            <button
              id={`btnDownloadFile-${rowIndex}`}
              type="button"
              className="btn btn-dark"
              onClick={() => this.downloadFile(row)}
            >
              <i className="fa fa-download"></i>
            </button>
          </CTooltip>
        </Fragment>
      )}
    </div>
  );

  cellProgress = (cell, row, enumObject, rowIndex) => {
    let progressNum = parseInt(row.progress);

    let color;
    if (progressNum < 30) {
      color = "danger";
    } else if (progressNum < 70) {
      color = "info";
    } else {
      color = "success";
    }

    return (
      <Fragment>
        <small className="small">{progressNum}%</small>
        <CProgress color={color} value={progressNum} />
      </Fragment>
    );
  };

  cellCommon = (cell, row, enumObject, rowIndex) => (
    <span title={cell}>{cell}</span>
  );

  upload = row => {
    this.props.uploadAction(row);
  };

  accept = row => {
    this.props.acceptAction(row);
  };

  pending = row => {
    this.props.pendingAction(row);
  };

  view = row => {
    const url =
      (this.props.viewPath ? this.props.viewPath : this.props.path) +
      row.id +
      (this.props.viewQuery ? this.props.viewQuery(row) || "" : "");

    if (this.props.viewBlank) {
      window.open(url, "_blank");
    } else if (this.props.viewAction) {
      this.props.viewAction(row);
    } else {
      this.props.history.push(url);
    }
  };

  importStudents = row => {
    this.props.importStudentsAction(row);
  };

  ranking = row => {
    this.props.rankingAction(row);
  };

  click = row => {
    if (this.props.editAction) {
      this.props.editAction(row);
      return;
    }

    if (this.props.pushState) {
      this.props.history.replace({
        ...this.props.history.location,
        state: { ...this.props.pushState }
      });
    }
    return this.props.history.push(this.props.path + row.id);
  };

  members = row => this.props.history.push(this.props.membersPath + row.id);

  migrate = row => {
    const url = this.props.pathMigrate + row.id;
    this.props.history.push(url);
  };

  duplicate = row => {
    this.props.duplicateAction(row);
  };

  statistics = row => {
    this.props.handleStatistic(row.id, row.name);
  };

  delete = row => {
    if (this.props.deletebtnAction) {
      this.props.deletebtnAction(row);
    }
  };

  print = row => {
    this.props.printAction(row);
  };

  allocate = row => {
    if (this.props.allocateAction) {
      this.props.allocateAction(row);
      return;
    }
    this.props.history.push(`/trail/allocate/${row.id}`);
  };

  report = row => {
    this.props.reportAction(row);
  };

  downloadFile = row => {
    this.props.downloadFileAction(row);
  };

  changePassword = row => {
    this.props.passwordAction(row);
  };

  answerKeyAction = row => {
    this.props.answerKeyAction(row);
  };

  onRowSelect = (row, isSelected, e) => {
    let { selectedList } = this.state;

    selectedList.push(row.id);
    this.setState(
      {
        selectedList
      },
      () => {
        if (this.props.getSelected) {
          this.props.getSelected(this.state.selectedList);
        }
      }
    );
  };

  selectRow = {
    mode: "checkbox",
    onSelect: this.onRowSelect
  };

  getOptions() {
    return {
      defaultSortName: this.props.noSort ? undefined : "id",
      defaultSortOrder: this.props.defaultSortOrder || "desc",
      sortIndicator: true,
      paginationSize: 3,
      paginationPosition: "bottom",
      paginationPanel: this.renderPaginationPanel,
      sizePerPage:
        this.props.remote || this.props.paginationData
          ? this.props.perPage || this.props.paginationData.sizePerPage
          : 10,
      onPageChange: this.props.remote ? this.props.onPageChange : undefined,
      onSizePerPageList: this.props.remote
        ? this.props.onSizePerPageList
        : undefined,
      page: this.props.remote ? this.props.currentPage : undefined,
      sizePerPageList: [
        { text: "10", value: 10 },
        { text: "30", value: 30 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        {
          text: "Todos",
          value: this.props.remote
            ? this.props.totalItems
            : this.props.list.length
        }
      ],
      sizePerPageDropDown: this.renderSizePerPageDropDown,
      paginationShowsTotal: this.renderPaginationShowsTotal,
      alwaysShowAllBtns: true,
      withFirstAndLast: false,
      insertBtn: this.createCustomInsertButton,
      toolBar: this.createCustomToolBar,
      exportCSVBtn: this.createCustomExportCSVButton,
      deleteBtn: this.createCustomDeleteButton,
      searchField: this.createCustomSearchField,
      onDeleteRow: this.onDeleteRow,
      handleConfirmDeleteRow: this.customConfirm,
      noDataText: this.props.noDataIndication || "A tabela está vazia",
      onRowMouseOver: this.onRowMouseOver,
      onRowMouseOut: this.onRowMouseOut,
      onRowClick: !this.props.action && !this.props.noClick && this.click
    };
  }

  getArray = data => {
    const header =
      this.state?.header
        ?.filter(item => item.denomination !== "Ações")
        .map(item => item.denomination) || [];
    const attList =
      this.state?.header
        ?.filter(item => item.name !== "action")
        .map(item => item.name) || [];

    const arr = [header];

    data.forEach((item, index) => {
      let itemDataToPrint = [];
      attList.forEach((att, index) => {
        if (!Array.isArray(item[att])) {
          itemDataToPrint.push(item[att] || "");
        } else {
          itemDataToPrint.push(item[att].map(item => item.name).join(", "));
        }
      });
      arr.push(itemDataToPrint);
    });

    return arr;
  };

  render() {
    return (
      <>
        <div className="animated printPDF dt-root">
          {this.props?.list?.length > 0 && (
            <div className="d-flex w-100 justify-content-end mt-3 mb-2 dt-export-bar">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToXLSX(
                    this.getArray(this.props.list),
                    `${this.props.title}.xlsx`
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLSX
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToXLS(
                    this.getArray(this.props.list),
                    `${this.props.title}.xls`
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLS
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToCSV(
                    this.getArray(this.props.list),
                    `${this.props.title}.csv`
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para CSV
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  elementToPDF("printPDF", `${this.props.title}.pdf`)
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
              </CButton>
            </div>
          )}
          <CCard>
            <CCardBody className="p-0">
              <BootstrapTable
                data={this.props.list}
                fetchInfo={
                  this.props.remote && { dataTotalSize: this.props.totalItems }
                }
                csvFileName={`${this.props.title}.csv`}
                version="4"
                data-pagination-h-align="top"
                striped
                hover
                remote={this.props.remote === true}
                pagination
                search={!this.props.noSearch ?? !this.props.remote}
                scrollTop="bottom"
                options={this.getOptions()}
                keyField="id"
                insertRow={!!this.props.insert}
                deleteRow={!!this.props.delete}
                exportCSV={!!this.props.csv}
                selectRow={
                  this.props.delete || this.props.csv ? this.selectRow : ""
                }
                trClassName={this.props.trClassName}
                noDataIndication={
                  this.props.noDataIndication || "A tabela está vazia"
                }
                tableContainerClass={
                  this.props.responsiveCards || this.props.mobileCard
                    ? "dt-cards"
                    : undefined
                }
              >
                {this.state.header.map((column, idx) => {
                  if (this.props.action && column.name === "action") {
                    return (
                      <TableHeaderColumn
                        key={idx}
                        dataField="button"
                        dataFormat={this.cellButton}
                        width={column.width}
                        columnClassName="action-cell"
                        tdAttr={{ "data-label": column.denomination }}
                      >
                        {column.denomination}
                      </TableHeaderColumn>
                    );
                  }
                  if (this.props.progressField && column.name === "progress") {
                    return (
                      <TableHeaderColumn
                        key={idx}
                        dataField="button"
                        dataFormat={this.cellProgress}
                        tdAttr={{ "data-label": column.denomination }}
                      >
                        {column.denomination}
                      </TableHeaderColumn>
                    );
                  }
                  if (column.name === "id") {
                    return (
                      <TableHeaderColumn
                        width={column.width || "65"}
                        key={idx}
                        dataField={column.name}
                        dataSort={"dataSort" in column ? column.dataSort : true}
                        dataFormat={this.cellCommon}
                        className={column.className}
                        columnClassName={column.className}
                        tdAttr={{ "data-label": column.denomination }}
                      >
                        {column.denomination}
                      </TableHeaderColumn>
                    );
                  }
                  return (
                    <TableHeaderColumn
                      key={idx}
                      dataField={column.name}
                      dataSort={"dataSort" in column ? column.dataSort : true}
                      sortFunc={column.sortFunc}
                      width={column.width}
                      dataFormat={column.dataFormat || this.cellCommon}
                      className={column.className}
                      columnClassName={column.className}
                      tdAttr={{ "data-label": column.denomination }}
                    >
                      {column.denomination}
                    </TableHeaderColumn>
                  );
                })}
              </BootstrapTable>
            </CCardBody>
          </CCard>
        </div>
      </>
    );
  }
}

export default withRouter(DataTable);
